"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBroadcastChannel = void 0;
const react_1 = require("react");
function useBroadcastChannel(channelName, handleMessage, handleMessageError) {
    const channelRef = (0, react_1.useRef)(typeof window !== 'undefined' && 'BroadcastChannel' in window
        ? new BroadcastChannel(channelName + '-channel')
        : null);
    useChannelEventListener(channelRef, 'message', handleMessage);
    useChannelEventListener(channelRef, 'messageerror', handleMessageError);
    return (0, react_1.useCallback)((data) => {
        var _a;
        (_a = channelRef === null || channelRef === void 0 ? void 0 : channelRef.current) === null || _a === void 0 ? void 0 : _a.postMessage(data);
    }, [channelRef]);
}
exports.useBroadcastChannel = useBroadcastChannel;
function useChannelEventListener(channelRef, event, handler = () => { }) {
    (0, react_1.useEffect)(() => {
        const channel = channelRef.current;
        if (channel) {
            channel.addEventListener(event, handler);
            return () => channel.removeEventListener(event, handler);
        }
    }, [channelRef, event, handler]);
}
